import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2df0b8aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "edit-mode"
}
const _hoisted_2 = {
  key: 0,
  class: "birth-year"
}
const _hoisted_3 = {
  key: 1,
  class: "selected-person"
}
const _hoisted_4 = ["disabled", "onClick"]
const _hoisted_5 = {
  key: 0,
  class: "birth-year"
}

import { computed, nextTick, onUnmounted, ref } from 'vue'
import { onClickOutside } from '@vueuse/core'
import { Person } from '@webapp/rd/ResearchDataModel'
import { useLiveSearch } from '@webapp/util/LiveSearch'
import { useSyncSessionStore } from './SyncSessionStore'
import SearchInput from '@webapp/util/SearchInput.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SourcePersonSelector',
  props: {
    sessionId: {},
    modelValue: {},
    placeholder: {},
    disabled: { type: Boolean }
  },
  emits: [
  'update:modelValue',
  'focus',
],
  setup(__props: any, { expose: __expose, emit }) {

const props = __props;





__expose({
  focus: () => searchInputRef.value?.focus(),
  reset,
})

const syncSessionStore = useSyncSessionStore()
const stateRef = computed(() => syncSessionStore.getState(props.sessionId))

const placeholderRef = computed(() => props.placeholder ?? 'Type a name')
const selectedPersonRef = computed(() => getPerson(props.modelValue))

const showSearchInputRef = ref(false)
const selectorRef = ref<HTMLElement>()
const removeButtonRef = ref<HTMLButtonElement>()
const searchInputRef = ref<InstanceType<typeof SearchInput>>()

const { searchTextRef, searchResultsRef } = useLiveSearch<Person>(searchForPersonsAsync)

let stopClickOutside: (() => void) | undefined
onUnmounted(() => stopClickOutside?.())

function getPerson(id?: string) {
  return id ? stateRef.value?.sourceGraph?.persons.get(id) : undefined
}

async function searchForPersonsAsync(text: string) {
  const names = text.split(' ').map(n => n.trim().toLowerCase()).filter(n => n.length > 0)
  const persons = stateRef.value?.sourceGraph?.persons
  if (!persons) {
    return []
  }
  return [...persons.values()].filter(p => {
    const displayName = p.displayName?.toLowerCase() ?? ''
    return names.every(n => displayName.includes(n))
  })
}

async function searchResultSelected(id: string) {
  emit('update:modelValue', id)
  closeSearchInput()
  await nextTick()
  removeButtonRef.value?.focus()
}

async function onEdit(e: Event) {
  e.stopPropagation()
  showSearchInputRef.value = true
  await nextTick()
  searchInputRef.value?.focus()
  stopClickOutside?.()
  stopClickOutside = onClickOutside(selectorRef, () => closeSearchInput())
}

function closeSearchInput() {
  showSearchInputRef.value = false
  stopClickOutside?.()
  stopClickOutside = undefined
}

function reset() {
  searchTextRef.value = ''
  searchInputRef.value?.reset()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "selectorRef",
    ref: selectorRef,
    class: "source-person-selector"
  }, [
    (showSearchInputRef.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(SearchInput, {
            ref_key: "searchInputRef",
            ref: searchInputRef,
            modelValue: _unref(searchTextRef),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(searchTextRef) ? (searchTextRef).value = $event : null)),
            "search-results": _unref(searchResultsRef),
            placeholder: placeholderRef.value,
            onFocus: _cache[1] || (_cache[1] = ($event: any) => (emit('focus'))),
            onResultSelected: searchResultSelected
          }, {
            default: _withCtx(({ item }) => [
              _createElementVNode("div", null, [
                _createTextVNode(_toDisplayString(getPerson(item.id)?.displayName) + " ", 1),
                (getPerson(item.id)?.displayProperties.birthYear)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, " (" + _toDisplayString(getPerson(item.id)?.displayProperties.birthYear) + ") ", 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "search-results", "placeholder"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            ref_key: "removeButtonRef",
            ref: removeButtonRef,
            class: "btn btn-inline btn-link",
            disabled: _ctx.disabled,
            onClick: _withModifiers(onEdit, ["stop"])
          }, [
            _createTextVNode(_toDisplayString(selectedPersonRef.value?.displayName ?? "Select a person") + " ", 1),
            (selectedPersonRef.value?.displayProperties.birthYear)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, " (" + _toDisplayString(selectedPersonRef.value?.displayProperties.birthYear) + ") ", 1))
              : _createCommentVNode("", true)
          ], 8, _hoisted_4)
        ]))
  ], 512))
}
}

})